import { jsx as _jsx } from "react/jsx-runtime";
import { SignIn } from "@clerk/clerk-react";
import { useEffect } from "react";
import styles from "../../styles/clerk.module.css";
const SignInPage = ({ redirect_url }) => {
    useEffect(() => {
        const interval = setInterval(() => {
            const mainDiv = document.querySelector("div.cl-main");
            if (mainDiv && !document.querySelector(".mailto-signup-message")) {
                const html = `
          <div class="${styles.mailtoSignupMessage}" style="text-align: center; margin-top: 1rem;">
            <p>No account? Contact <a href="mailto:access@tenkay.ai">access@tenkay.ai</a> to get started.</p>
          </div>
        `;
                mainDiv.insertAdjacentHTML("afterend", html);
                clearInterval(interval);
            }
        }, 50);
        return () => clearInterval(interval);
    }, []);
    return (_jsx(SignIn, { appearance: {
            elements: {
                footer: styles.footer,
                rootBox: "mx-auto max-w-full",
                card: "max-w-full",
            },
        }, redirectUrl: redirect_url }));
};
export default SignInPage;
